// YERİ: src/app/domains/site/sections/payment-box.section.ts
//
// ÖDEME AL — ziyaretçinin karttan ödeme yaptığı bölüm.
//
// ── TUTARI SUNUCU BELİRLER ─────────────────────────────────────────────────
// Buradaki fiyatlar yalnız GÖSTERİM. Sunucuya kalemin SIRASI gönderilir,
// tutarı sunucu bölümün veritabanındaki yapılandırmasından okur. Ekrandaki
// rakamı düzenleyip tutarı değiştirmek mümkün değildir.
//
// Serbest tutar (bağış, "dilediğin kadar öde") açıksa tutar gönderilir ama
// sunucu yine bölümün alt/üst sınırına bakar.
//
// ── ÖDENDİ BİLGİSİ ─────────────────────────────────────────────────────────
// Kart onaylandığında ekranda teşekkür gösterilir, ama kaydı "ödendi" yapan
// tek şey Stripe webhook'udur. Tarayıcının sözüne göre para durumu yazılmaz.
//
// config: { eyebrow, title, subtitle, currency, items[{name,description,amount}],
//           allowCustom, customLabel, minAmount, maxAmount, buttonText, note }

import { Component, computed, inject, input, signal } from '@angular/core';
import { SiteChromeText } from '../core/site-chrome-text';
import { TenantWebService } from '../core/tenant-web.service';
import { SiteConfig, cfg } from './section.model';
import { StripeElementLike, StripeElementsLike, StripeLike, loadStripe } from '../core/stripe-loader';

interface OdemeKalemi {
  name?: string;
  description?: string;
  amount?: string | number;
}

@Component({
  selector: 'sec-payment-box',
  standalone: true,
  template: `
    <section id="payment" class="bg-neutral-50 py-24 dark:bg-neutral-900">
      <div class="mx-auto max-w-2xl px-6 lg:px-8">
        <div class="text-center">
          @if (eyebrow()) {
            <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          }
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">
            {{ title() }}
          </h2>
          @if (subtitle()) {
            <p class="mx-auto mt-4 max-w-xl text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p>
          }
        </div>

        <div class="mt-10 rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm dark:border-neutral-800 dark:bg-neutral-950 sm:p-8">

          @if (done()) {
            <div class="flex flex-col items-center py-8 text-center">
              <span class="flex size-14 items-center justify-center rounded-full text-white" style="background-color:var(--site-primary)">✓</span>
              <p class="mt-4 text-lg font-semibold text-neutral-900 dark:text-white">{{ metin.t('pb.success') }}</p>
              <p class="mt-1 text-sm text-neutral-500">{{ metin.t('pb.successHint') }}</p>
              <p class="mt-3 text-base font-semibold" style="color:var(--site-primary)">
                {{ tutarMetni(secilenTutar()) }}
              </p>
            </div>
          } @else if (!kalemler().length && !serbestAcik()) {
            <!-- Yapılandırılmamış bölüm: ziyaretçiye çalışmayan bir form
                 göstermek yerine durum açıkça yazılır. -->
            <p class="py-6 text-center text-sm text-neutral-400">{{ metin.t('pb.noItems') }}</p>
          } @else if (kartAdimi()) {
            <div>
              <div class="mb-4 flex items-baseline justify-between gap-3">
                <span class="text-sm text-neutral-500">{{ kalemAdi() }}</span>
                <span class="text-xl font-semibold text-neutral-900 dark:text-white">{{ tutarMetni(secilenTutar()) }}</span>
              </div>
              <div id="payment-box-element"></div>
              @if (hata()) { <p class="mt-3 text-sm text-rose-600">{{ hata() }}</p> }
              <button type="button"
                class="mt-5 w-full rounded-lg px-4 py-3 text-sm font-semibold text-white transition-opacity disabled:opacity-60"
                style="background-color:var(--site-primary)"
                [disabled]="odeniyor() || !kartHazir()"
                (click)="kartlaOde()">
                {{ odeniyor() ? metin.t('pb.paying') : (buttonText() || metin.t('pb.pay')) }}
              </button>
              <p class="mt-3 text-center text-xs text-neutral-400">{{ metin.t('pb.secured') }}</p>
            </div>
          } @else {
            <div class="flex flex-col gap-4">

              @if (kalemler().length || serbestAcik()) {
                <div>
                  <label class="mb-2 block text-xs font-medium text-neutral-500">{{ metin.t('pb.selectItem') }}</label>
                  <div class="flex flex-col gap-2">
                    @for (k of kalemler(); track $index) {
                      <button type="button"
                        class="flex items-start justify-between gap-3 rounded-xl border p-4 text-left transition-colors"
                        [class]="secim() === $index
                          ? 'border-[color:var(--site-primary)] bg-[color:var(--site-primary)]/5'
                          : 'border-neutral-200 hover:border-neutral-400 dark:border-neutral-700'"
                        (click)="secimYap($index)">
                        <span class="min-w-0">
                          <span class="block text-sm font-medium text-neutral-900 dark:text-white">{{ k.name }}</span>
                          @if (k.description) {
                            <span class="mt-0.5 block text-xs text-neutral-500">{{ k.description }}</span>
                          }
                        </span>
                        <span class="shrink-0 text-sm font-semibold" style="color:var(--site-primary)">
                          {{ tutarMetni(sayiya(k.amount)) }}
                        </span>
                      </button>
                    }

                    @if (serbestAcik()) {
                      <button type="button"
                        class="flex items-center justify-between gap-3 rounded-xl border p-4 text-left transition-colors"
                        [class]="secim() === -1
                          ? 'border-[color:var(--site-primary)] bg-[color:var(--site-primary)]/5'
                          : 'border-neutral-200 hover:border-neutral-400 dark:border-neutral-700'"
                        (click)="secimYap(-1)">
                        <span class="text-sm font-medium text-neutral-900 dark:text-white">
                          {{ customLabel() || metin.t('pb.customOption') }}
                        </span>
                      </button>
                    }
                  </div>
                </div>
              }

              @if (secim() === -1) {
                <div>
                  <label class="mb-1 block text-xs font-medium text-neutral-500">{{ metin.t('pb.amount') }}</label>
                  <div class="flex items-center gap-2">
                    <input type="number" min="0" step="0.01" inputmode="decimal"
                      class="w-full rounded-lg border border-neutral-300 bg-white px-3 py-2.5 text-sm dark:border-neutral-700 dark:bg-neutral-900"
                      [value]="serbestTutar() ?? ''"
                      (input)="serbestTutarYaz($any($event.target).value)" />
                    <span class="text-sm font-medium text-neutral-500">{{ currency() }}</span>
                  </div>
                  <p class="mt-1 text-xs text-neutral-400">
                    {{ metin.t('pb.amountRange', { min: minAmount(), currency: currency() }) }}
                  </p>
                </div>
              }

              <div class="grid gap-4 sm:grid-cols-2">
                <div>
                  <label class="mb-1 block text-xs font-medium text-neutral-500">{{ metin.t('pb.payerName') }}</label>
                  <input type="text"
                    class="w-full rounded-lg border border-neutral-300 bg-white px-3 py-2.5 text-sm dark:border-neutral-700 dark:bg-neutral-900"
                    [value]="ad()" (input)="ad.set($any($event.target).value)" />
                </div>
                <div>
                  <label class="mb-1 block text-xs font-medium text-neutral-500">{{ metin.t('pb.email') }}</label>
                  <input type="email" autocomplete="email"
                    class="w-full rounded-lg border border-neutral-300 bg-white px-3 py-2.5 text-sm dark:border-neutral-700 dark:bg-neutral-900"
                    [value]="eposta()" (input)="eposta.set($any($event.target).value)" />
                </div>
              </div>
              <p class="-mt-2 text-xs text-neutral-400">{{ metin.t('pb.emailHint') }}</p>

              <div>
                <label class="mb-1 block text-xs font-medium text-neutral-500">{{ metin.t('pb.note') }}</label>
                <textarea rows="2"
                  class="w-full rounded-lg border border-neutral-300 bg-white px-3 py-2.5 text-sm dark:border-neutral-700 dark:bg-neutral-900"
                  [value]="not()" (input)="not.set($any($event.target).value)"></textarea>
              </div>

              @if (note()) { <p class="text-xs text-neutral-500">{{ note() }}</p> }
              @if (hata()) { <p class="text-sm text-rose-600">{{ hata() }}</p> }

              <button type="button"
                class="mt-1 w-full rounded-lg px-4 py-3 text-sm font-semibold text-white transition-opacity disabled:opacity-60"
                style="background-color:var(--site-primary)"
                [disabled]="hazirlaniyor() || preview()"
                (click)="devamEt()">
                {{ hazirlaniyor() ? metin.t('pb.preparing') : metin.t('pb.continue') }}
              </button>

              @if (preview()) {
                <p class="text-center text-xs text-neutral-400">{{ metin.t('pb.previewNote') }}</p>
              } @else {
                <p class="text-center text-xs text-neutral-400">{{ metin.t('pb.secured') }}</p>
              }
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class PaymentBoxSection {
  /** Ziyaretçiye görünen kabuk metinleri — dil sitenin ayarından. */
  protected metin = inject(SiteChromeText);
  private svc = inject(TenantWebService);

  config = input<SiteConfig>({});
  clientId = input<number>(0);
  /** Bölümün DB kimliği — tutarın kaynağı sunucuda bununla bulunur. */
  sectionId = input<number>(0);
  /** Editör önizlemesi: gerçek tahsilat yapılmaz. */
  preview = input(false);

  protected eyebrow  = computed(() => cfg(this.config(), 'eyebrow', ''));
  protected title    = computed(() => cfg(this.config(), 'title', this.metin.t('pb.title')));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', ''));
  protected note     = computed(() => cfg(this.config(), 'note', ''));
  protected buttonText = computed(() => cfg(this.config(), 'buttonText', ''));
  protected customLabel = computed(() => cfg(this.config(), 'customLabel', ''));
  protected currency = computed(() => (cfg(this.config(), 'currency', 'CAD') || 'CAD').toUpperCase());

  protected kalemler = computed<OdemeKalemi[]>(() => {
    const ham = this.config()?.['items'];
    return Array.isArray(ham) ? ham.filter(k => k && (k.name || k.amount)) : [];
  });

  /** Serbest tutar YALNIZ açıkça 'true' ise; şema select'i dize döndürüyor. */
  protected serbestAcik = computed(() => String(cfg(this.config(), 'allowCustom', 'false')) === 'true');
  protected minAmount = computed(() => this.sayiya(cfg(this.config(), 'minAmount', '')) ?? 1);
  private maxAmount = computed(() => this.sayiya(cfg(this.config(), 'maxAmount', '')));

  /** Seçili kalemin sırası; -1 = serbest tutar; null = seçim yok. */
  protected secim = signal<number | null>(null);
  protected serbestTutar = signal<number | null>(null);

  protected ad = signal('');
  protected eposta = signal('');
  protected not = signal('');

  protected hazirlaniyor = signal(false);
  protected odeniyor = signal(false);
  protected kartAdimi = signal(false);
  protected kartHazir = signal(false);
  protected done = signal(false);
  protected hata = signal<string | null>(null);

  private stripe: StripeLike | null = null;
  private elements: StripeElementsLike | null = null;
  private paymentElement: StripeElementLike | null = null;

  protected secilenTutar = computed<number | null>(() => {
    const s = this.secim();
    if (s === -1) return this.serbestTutar();
    if (s === null) return null;
    return this.sayiya(this.kalemler()[s]?.amount);
  });

  protected kalemAdi = computed(() => {
    const s = this.secim();
    if (s === -1) return this.customLabel() || this.metin.t('pb.customOption');
    return s === null ? '' : (this.kalemler()[s]?.name ?? '');
  });

  protected secimYap(i: number): void {
    this.secim.set(i);
    this.hata.set(null);
  }

  protected serbestTutarYaz(raw: string): void {
    const v = Number(raw);
    this.serbestTutar.set(Number.isFinite(v) && v > 0 ? v : null);
  }

  protected tutarMetni(v: number | null): string {
    if (v == null) return '';
    return `${v.toLocaleString(this.metin.dil() || 'tr', {
      minimumFractionDigits: 0, maximumFractionDigits: 2,
    })} ${this.currency()}`;
  }

  protected sayiya(v: unknown): number | null {
    if (v == null || v === '') return null;
    if (typeof v === 'number') return Number.isFinite(v) ? v : null;

    // Esnaf tutarı serbest metin yazıyor: "1.200,50", "$120", "120 CAD".
    // Son ayraç ondalık kabul edilir, öncekiler binlik ayracıdır.
    const temiz = String(v).replace(/[^\d.,-]/g, '');
    if (!temiz) return null;
    const pos = Math.max(temiz.lastIndexOf('.'), temiz.lastIndexOf(','));
    const normal = pos < 0
      ? temiz
      : temiz.slice(0, pos).replace(/[.,]/g, '') + '.' + temiz.slice(pos + 1).replace(/[.,]/g, '');
    const n = Number(normal);
    return Number.isFinite(n) ? n : null;
  }

  /** Form doğrulaması → PaymentIntent → Stripe Elements. */
  protected devamEt(): void {
    if (this.hazirlaniyor() || this.preview()) return;
    this.hata.set(null);

    if (this.secim() === null) { this.hata.set(this.metin.t('pb.selectRequired')); return; }
    if (!this.ad().trim())     { this.hata.set(this.metin.t('pb.nameRequired')); return; }
    if (!/^\S+@\S+\.\S+$/.test(this.eposta().trim())) {
      this.hata.set(this.metin.t('pb.emailRequired')); return;
    }

    const tutar = this.secilenTutar();
    if (tutar == null || tutar <= 0) { this.hata.set(this.metin.t('pb.amountRequired')); return; }

    if (this.secim() === -1) {
      const max = this.maxAmount();
      if (tutar < this.minAmount() || (max != null && max > 0 && tutar > max)) {
        this.hata.set(this.metin.t('pb.amountRequired'));
        return;
      }
    }

    this.hazirlaniyor.set(true);

    this.svc.createSectionPaymentIntent(this.clientId(), {
      sectionId: this.sectionId(),
      // Serbest tutarda kalem sırası GÖNDERİLMEZ: sunucu sıra geldiğinde
      // tutarı kalemden okur ve girilen tutarı yok sayardı.
      itemIndex: this.secim() === -1 ? null : this.secim(),
      amount: this.secim() === -1 ? tutar : null,
      payerName: this.ad().trim(),
      payerEmail: this.eposta().trim(),
      note: this.not().trim() || null,
    }).subscribe({
      next: async sonuc => {
        if (!sonuc?.clientSecret || !sonuc.publishableKey) {
          this.hazirlaniyor.set(false);
          this.hata.set(this.metin.t('pb.initFailed'));
          return;
        }

        this.stripe = await loadStripe(sonuc.publishableKey);
        if (!this.stripe) {
          // Betik engellenmiş olabilir (reklam engelleyici, ağ). Kayıt
          // sunucuda 'pending' duruyor; ziyaretçi boş ekranla kalmasın.
          this.hazirlaniyor.set(false);
          this.hata.set(this.metin.t('pb.formFailed'));
          return;
        }

        this.kartAdimi.set(true);
        this.hazirlaniyor.set(false);

        // Elements ancak hedef eleman DOM'a girdikten sonra monte edilebilir.
        queueMicrotask(() => {
          this.elements = this.stripe!.elements({ clientSecret: sonuc.clientSecret });
          this.paymentElement = this.elements.create('payment');
          this.paymentElement.mount('#payment-box-element');
          this.kartHazir.set(true);
        });
      },
      error: () => {
        this.hazirlaniyor.set(false);
        this.hata.set(this.metin.t('pb.initFailed'));
      },
    });
  }

  protected async kartlaOde(): Promise<void> {
    if (!this.stripe || !this.elements || this.odeniyor()) return;
    this.odeniyor.set(true);
    this.hata.set(null);

    const res = await this.stripe.confirmPayment({
      elements: this.elements,
      // redirect:'if_required' — 3D Secure gerekmiyorsa sayfada kalırız.
      redirect: 'if_required',
    });

    this.odeniyor.set(false);

    if (res.error) {
      this.hata.set(res.error.message || this.metin.t('pb.failed'));
      return;
    }

    // DİKKAT: kaydı "ödendi" YAPMIYORUZ. Bunu yalnız imza doğrulamalı Stripe
    // webhook'u yazar; tarayıcıdan gelen "başarılı" bilgisine göre para
    // durumu değiştirmek uydurma istekle bedava tahsilat demek olurdu.
    this.paymentElement?.unmount();
    this.kartAdimi.set(false);
    this.done.set(true);
  }
}
